<template>
  <div class="appBody prh-main bg-grey-light w-100">
    <tabbar-component class="bigTab" :type="bigTab" :tabbarList="tabArr"></tabbar-component>

    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="getTeacherById"
      class="bg-white">
      <row-card-component :cardList="zhuanlanList" typeBlock="lec_zhuanlan"
                          class="pb-28 border-bottom-0 mt-2">
        <div class=" bg-white d-flex align-items-center justify-content-between">
          <h6 class="b-title px-0 mb-0 bg-white">专栏</h6>
        </div>
      </row-card-component>

    </van-list>

    <little-footer></little-footer>
  </div>
</template>

<script>
  import Vue from 'vue';
  import {List} from 'vant';

  Vue.use(List);

  import TabbarComponent from '@/components/tabbarComponent';
  import RowCardComponent from "@/components/rowCardComponent";
  import LittleFooter from '@/page/lecturer/components/littleFooter';

  export default {
    name: "lecZhuanlanList",
    components: {
      TabbarComponent,
      RowCardComponent,
      LittleFooter,
    },
    data() {
      return {
        tabArr: [],
        bigTab: 'bigTab',
        zhuanlanList: [],
        loading: false,
        finished: false,
        tid: ''
      }
    },
    mounted() {
      this.tid = this.$route.params.uid;
      this.getTeacherById();
      this.tabArr = [
        {
          title: '讲师',
          icon: '/static/img/index/zj-1.png',
          link: '/lecturer/' + this.tid
        },
        {
          title: '课程',
          icon: '/static/img/pro/course_nav.png',
          link: '/lecturer/course/list/' + this.tid
        },
        {
          title: '直播',
          icon: '/static/img/pro/zhibo_nav.png',
          link: '/lecturer/zhibo/list/' + this.tid
        }
      ];
    },
    methods: {
      getTeacherById() {
        this.loading = true;
        this.$store.dispatch('getLectureById').then((res) => {
          this.zhuanlanList = res[0].zhuanlanList;
          this.loading = false;
          if (this.zhuanlanList.length < 10) {
            this.finished = true;
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>
